<template>
  <div class="mosaic-form">
    <v-form
      ref="form"
      @submit.prevent="salvarConfiguracao"
      id="insert-configuracao-mosaico"
      v-model="valid"
    >
      <!-- Name -->
      <div class="form-section">
        <label class="form-label">Nome da configuração</label>
        <v-text-field
          solo
          flat
          dense
          placeholder="Ex: Padrão GE, BBB Noite..."
          v-model="dscNomeConfig"
          :rules="nameRules"
          background-color="surface_tertiary"
          hide-details="auto"
          required
        ></v-text-field>
      </div>

      <!-- Preview -->
      <div class="form-section">
        <label class="form-label">Prévia</label>
        <div
          class="form-preview"
          :style="{
            'background-image': urlImage ? `url(${urlImage})` : 'none',
            'background-size': 'cover',
            'background-color': backgroundProperty,
          }"
        >
          <CardMosaicoGaleria
            :content="{
              dsc_texto_colaboracao: 'Este é um exemplo de texto que você pode ter nos cards do mosaico.',
              dsc_nome_colaborador: 'Nome de usuário',
              dsc_fonte_colaboracao: 'twitter',
            }"
            :card-config="{
              dscCorCard: colorProperties.card.formValue,
              dscCorFonte: colorProperties.fonte.formValue,
            }"
          />
        </div>
      </div>

      <!-- Colors -->
      <div class="form-section">
        <label class="form-label">Cores</label>
        <div class="form-colors">
          <div
            v-for="property in Object.keys(colorProperties)"
            :key="`color-${property}`"
            class="form-color-item"
          >
            <v-menu :close-on-content-click="false" transition="scroll-y-transition">
              <template v-slot:activator="{ on, attrs }">
                <div class="form-color-trigger" v-bind="attrs" v-on="on">
                  <div
                    class="form-color-dot"
                    :style="{ 'background-color': colorProperties[property].formValue }"
                  ></div>
                  <span class="form-color-name">{{ property }}</span>
                  <v-icon x-small class="form-color-edit">mdi-pencil</v-icon>
                </div>
              </template>
              <v-color-picker
                dot-size="20"
                mode="hexa"
                v-model="colorProperties[property].formValue"
              ></v-color-picker>
            </v-menu>
          </div>
        </div>
      </div>

      <!-- Background -->
      <div class="form-section">
        <label class="form-label">Fundo</label>
        <div class="form-background">
          <v-btn-toggle v-model="backgroundType" mandatory dense class="form-bg-toggle">
            <v-btn value="Cor" small :disabled="!!urlImage">
              <v-icon small class="mr-1">mdi-palette</v-icon>
              Cor
            </v-btn>
            <v-btn value="Imagem" small>
              <v-icon small class="mr-1">mdi-image</v-icon>
              Imagem
            </v-btn>
          </v-btn-toggle>

          <div class="form-bg-control">
            <template v-if="backgroundType === 'Cor'">
              <v-menu :close-on-content-click="false" transition="scroll-y-transition">
                <template v-slot:activator="{ on, attrs }">
                  <div class="form-color-trigger" v-bind="attrs" v-on="on">
                    <div
                      class="form-color-dot"
                      :style="{ 'background-color': backgroundProperty }"
                    ></div>
                    <span class="form-color-hex">{{ backgroundProperty }}</span>
                    <v-icon x-small class="form-color-edit">mdi-pencil</v-icon>
                  </div>
                </template>
                <v-color-picker
                  mode="hexa"
                  v-model="backgroundProperty"
                  dot-size="20"
                ></v-color-picker>
              </v-menu>
            </template>
            <template v-else>
              <div v-if="!urlImage" class="form-image-upload" @click="$refs.fileInput.$el.querySelector('input').click()">
                <v-icon small color="text_secondary">mdi-cloud-upload</v-icon>
                <span>Escolher imagem</span>
                <v-file-input
                  ref="fileInput"
                  hide-input
                  clear-icon=""
                  @change="onSelectImage"
                  accept="image/png, image/jpeg, image/jpg"
                  style="display: none"
                />
              </div>
              <div v-else class="form-image-selected">
                <v-icon small class="mr-1" color="primary">mdi-image-check</v-icon>
                <span class="form-image-name">{{ (fileName || '').substring(0, 20) }}</span>
                <v-btn
                  icon
                  x-small
                  :loading="isImageDeleteLoading"
                  @click.prevent="onDeleteImage"
                  class="form-image-remove"
                >
                  <v-icon small>mdi-close</v-icon>
                </v-btn>
              </div>
            </template>
          </div>
        </div>
      </div>
    </v-form>

    <!-- Actions -->
    <div class="form-footer">
      <v-btn text @click="$emit('cancel')" class="modal-btn-cancel">
        Cancelar
      </v-btn>
      <v-btn
        color="primary"
        type="submit"
        form="insert-configuracao-mosaico"
        :loading="loadingSave"
        class="modal-btn-confirm"
      >
        <v-icon small class="mr-1">mdi-check</v-icon>
        Salvar
      </v-btn>
    </div>
  </div>
</template>

<script>
import CardMosaicoGaleria from "@/components/Cards/CardMosaicoGaleria.vue";
import { apiClient } from "@/services/api";

export default {
  name: "ConfigMosaicoForm",
  components: { CardMosaicoGaleria },
  props: {
    codProducao: { type: Number, required: true },
    siglaProducao: { type: String, required: true },
    editConfig: { type: Object, default: null },
  },
  data() {
    return {
      backgroundType: "Cor",
      backgroundTypes: ["Cor", "Imagem"],
      colorProperties: {
        card: { key: "dscCorCard", formValue: "#121212FF" },
        fonte: { key: "dscCorFonte", formValue: "#FFFFFF" },
      },
      backgroundProperty: "#FFFFFFFF",
      dscNomeConfig: "",
      valid: false,
      loadingSave: false,
      configEditId: null,
      imageFile: undefined,
      fileName: undefined,
      urlImage: undefined,
      isImageDeleteLoading: false,
      isValidateImage: false,
      nameRules: [
        (v) => !!v || "O nome deve ser informado",
        (v) => v.length > 3 || "O nome deve conter mais de 3 letras",
      ],
      fileRules: [
        (v) => !!v || "Uma imagem deve ser selecionada",
        (v) => v?.size < 5000000 || "O arquivo deve ser menor que 5MB",
      ],
    };
  },
  beforeDestroy() {
    this.revokeObjectUrl();
  },
  computed: {
    isEditMode() {
      return !!this.editConfig;
    },
  },
  watch: {
    editConfig: {
      immediate: true,
      handler(config) {
        if (config) {
          this.configEditId = config.idConfigMosaico;
          this.dscNomeConfig = config.dscNomeConfig;
          this.backgroundProperty = config.dscCorBackground;
          this.colorProperties.card.formValue = config.dscCorCard;
          this.colorProperties.fonte.formValue = config.dscCorFonte;
          this.fileName = config.dscImgBackground
            ? config.dscImgBackground.split("/")[2]
            : null;
          this.isValidateImage = !this.fileName;
          this.urlImage = config.urlImgBackground;
          this.backgroundType = this.urlImage ? "Imagem" : "Cor";
        } else {
          this.resetForm();
        }
      },
    },
  },
  methods: {
    resetForm() {
      this.dscNomeConfig = "";
      this.backgroundProperty = "#4F478BFF";
      this.colorProperties.card.formValue = "#88914CFF";
      this.colorProperties.fonte.formValue = "#864444";
      this.backgroundType = "Cor";
      this.configEditId = null;
      this.imageFile = undefined;
      this.fileName = undefined;
      this.urlImage = undefined;
      this.isValidateImage = false;
    },
    revokeObjectUrl() {
      if (this.urlImage && this.urlImage.startsWith("blob:")) {
        URL.revokeObjectURL(this.urlImage);
      }
    },
    onSelectImage(e) {
      this.revokeObjectUrl();
      this.imageFile = e;
      this.fileName = this.imageFile?.name;
      this.urlImage = URL.createObjectURL(this.imageFile);
      this.isValidateImage = true;
    },
    async onDeleteImage() {
      this.isImageDeleteLoading = true;
      if (!this.urlImage || !this.urlImage.includes("blob")) {
        try {
          await apiClient.delete(
            `/deleteBucketImage?fileName=${this.fileName}&subpasta=backgrounds_mosaico/${this.siglaProducao}`
          );
          await apiClient.patch(
            `/producao/${this.codProducao}/mosaicoConfig/${this.configEditId}`,
            { urlImgBackground: "", dscImgBackground: "" }
          );
        } catch (ex) {
          this.$toast.error("Erro ao deletar imagem.");
          this.isImageDeleteLoading = false;
          return;
        }
      }
      this.revokeObjectUrl();
      this.fileName = undefined;
      this.urlImage = undefined;
      this.imageFile = undefined;
      this.isValidateImage = true;
      this.isImageDeleteLoading = false;
    },
    validate() {
      const validations = [];
      const applyValidation = (rules, fieldToValidate) => {
        rules.forEach((callbackFn) => {
          const output = callbackFn(fieldToValidate);
          if (typeof output === "string") {
            validations.push(output);
          }
        });
      };
      applyValidation(this.nameRules, this.dscNomeConfig);
      if (this.backgroundType === "Imagem" && this.isValidateImage) {
        applyValidation(this.fileRules, this.imageFile);
      }
      if (validations.length > 0) {
        this.loadingSave = false;
        this.$toast.error(validations[0]);
        return false;
      }
      return true;
    },
    async salvarConfiguracao() {
      this.loadingSave = true;
      if (!this.validate()) return;

      if (this.backgroundType === "Imagem" && this.urlImage.includes("blob")) {
        try {
          await apiClient.post(
            "/uploadFileToGCP",
            {
              file: this.imageFile,
              subpasta: `backgrounds_mosaico/${this.siglaProducao}`,
              fileName: this.fileName,
            },
            { headers: { "Content-Type": "multipart/form-data" } }
          );
          const response = await apiClient.get(
            `/getBucketImages?fileName=${this.fileName}&subpasta=backgrounds_mosaico/${this.siglaProducao}`
          );
          this.urlImage = response.data.url;
        } catch (error) {
          this.$toast.error("Erro ao fazer upload da imagem.");
          this.loadingSave = false;
          return;
        }
      }

      let configObject = {
        dscNomeConfig: this.dscNomeConfig,
        dscCorBackground: this.backgroundProperty,
        dscCorCard: this.colorProperties.card.formValue,
        dscCorFonte: this.colorProperties.fonte.formValue,
      };
      if (this.imageFile) {
        configObject = {
          ...configObject,
          dscImgBackground: `backgrounds_mosaico/${this.siglaProducao}/${this.imageFile?.name}`,
          urlImgBackground: this.urlImage,
        };
      }

      try {
        if (this.isEditMode) {
          await apiClient.patch(
            `/producao/${this.codProducao}/mosaicoConfig/${this.configEditId}`,
            configObject
          );
        } else {
          await apiClient.post(
            `/producao/${this.codProducao}/mosaicoConfig/`,
            configObject
          );
        }
        this.$toast.success("Configuração salva com sucesso");
        this.$emit("saved");
      } catch (error) {
        this.$toast.error(`Erro ao salvar configuração (${error.message})`);
      } finally {
        this.loadingSave = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.mosaic-form {
  padding: 20px 24px;
}

/* Sections */
.form-section {
  margin-bottom: 20px;
}

.form-label {
  display: block;
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--v-text_secondary-base);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
}

/* Preview */
.form-preview {
  border-radius: var(--sc-radius-lg);
  height: 240px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--sc-border-subtle);
  overflow: hidden;
}

/* Colors */
.form-colors {
  display: flex;
  gap: 12px;
}

.form-color-item {
  flex: 1;
}

.form-color-trigger {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  background: var(--sc-surface-tint);
  border: 1px solid var(--sc-border-emphasis);
  border-radius: var(--sc-radius-md);
  cursor: pointer;
  transition: all var(--sc-duration-base) var(--sc-easing-standard);

  &:hover {
    border-color: var(--sc-border-hover);
    background: var(--sc-surface-tint-hover);
  }
}

.form-color-dot {
  width: 28px;
  height: 28px;
  border-radius: var(--sc-radius-md);
  border: 2px solid var(--sc-border-hover);
  flex-shrink: 0;
}

.form-color-name {
  font-size: var(--sc-text-base);
  font-weight: 500;
  color: var(--v-text_primary-base);
  text-transform: capitalize;
  flex: 1;
}

.form-color-hex {
  font-size: 0.8rem;
  color: var(--v-text_secondary-base);
  font-family: monospace;
  flex: 1;
}

.form-color-edit {
  color: var(--v-text_secondary-base) !important;
  opacity: 0.5;
}

/* Background */
.form-background {
  display: flex;
  align-items: center;
  gap: 16px;
}

.form-bg-toggle {
  border-radius: var(--sc-radius-md) !important;
  overflow: hidden;

  .v-btn {
    text-transform: none !important;
    letter-spacing: 0 !important;
    font-weight: 500 !important;
  }
}

.form-bg-control {
  flex: 1;
}

.form-image-upload {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  background: var(--sc-surface-tint);
  border: 2px dashed var(--sc-border-default);
  border-radius: var(--sc-radius-md);
  cursor: pointer;
  transition: all var(--sc-duration-base) var(--sc-easing-standard);
  font-size: var(--sc-text-base);
  color: var(--v-text_secondary-base);

  &:hover {
    border-color: var(--v-primary-base);
    color: var(--v-primary-base);
  }
}

.form-image-selected {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 8px 14px;
  background: rgba(var(--sc-color-primary-rgb),0.06);
  border: 1px solid rgba(var(--sc-color-primary-rgb),0.2);
  border-radius: var(--sc-radius-md);
}

.form-image-name {
  font-size: 0.8rem;
  color: var(--v-text_primary-base);
  flex: 1;
}

.form-image-remove {
  &:hover {
    background: rgba(var(--sc-color-error-rgb),0.15) !important;
  }
}

/* Footer */
.form-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding-top: 16px;
  border-top: 1px solid var(--sc-border-subtle);
}

</style>
